import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { Image } from 'react-bootstrap';
import { fromNowToEndDate } from '../../../../common/utils/utils';
import { ResponseEvent } from '../../../../services/api/models/response/responseEvent';
import { LiveProps } from '../../LiveContainer';
import LiveMatch from '../../../live-match/components/LiveMatch/LiveMatch';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';

interface LiveEventItemProps {
  liveProps: LiveProps;
  event: ResponseEvent;
}

export const LiveEventItem = (props: LiveEventItemProps): ReactElement => {
  const [countDownTime, setCountDownTime] = useState('--:--');
  const liveMatchData = useSelector(
    (state: AppState) => state.liveMatch.liveMatchData,
  );
  const eventRank = useMemo(() => {
    return props.liveProps.liveState.eventRankings?.find(
      (rank) => rank.eventId === props.event.id,
    );
  }, [props.liveProps.liveState.eventRankings, props.event.id]);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const endDate = new Date(props.event.endDateTime);
      if (now > endDate) {
        clearInterval(timer);
        setCountDownTime('終了しました');
        return;
      }
      setCountDownTime(fromNowToEndDate(props.event?.endDateTime, true));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      {!liveMatchData && (
        <div className="live-event-banner__item">
          <Image
            src={props.event?.icon?.uri}
            onClick={() => {
              props.liveProps.showEventModal(props.event);
            }}
            className="live-event-banner__icon"
          ></Image>
          {eventRank && (
            <div
              className={`live-event-banner__rank${
                eventRank.fixed ? ' fixed' : ''
              }`}
            >
              {isNaN(Number(eventRank.rank))
                ? eventRank.rank
                : `${Number(eventRank.rank) > 99 ? '99+' : eventRank.rank} 位`}
            </div>
          )}
          <div className="live-event-banner__countdown">{countDownTime}</div>
        </div>
      )}
    </>
  );
};
